import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph,
  Heading1,
  Heading2,
  Heading3,
  List,
  LinkStyled,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Classic">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Classic</Heading1>
        </Col>
        <Col md={12} paddingTop="0px">
          <Paragraph>
            En classic øl er en mørk pilsner, der som oftest er let syrlig og desuden har en karakter af malt og let bitterhed fra humlen. En classic øl kan desuden ofte kendes på dens dybe farve, der som regel er rav rød eller kobberfarvet. Du finder typisk en variant af en classic i sortimentet hos de fleste danske bryggerier, da det er en øltype, der ligger mange danskeres hjerte nært.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelClassic" filterLiterPrice filterFadkobling filterLiterSize display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Classic øl på fad
          </Heading2>
          <Paragraph>
            Hos Skafte finder du et bredt udvalg af velsmagende og forfriskende classic øl på fad. Har du også behov for at <LinkStyled to="/fadoelsanlaeg">leje et fadølsanlæg</LinkStyled> til dit næste arrangement i samme omgang? Vi har heldigvis masser af ledige anlæg, så du og dine gæster kan nyde en frisk skænket classic øl fra fad.
          </Paragraph>
          <Paragraph>
            Vi tilbyder fustager med classic pilsner på enten 15, 20, 25 eller 30 liter og langt størstedelen har en S-kobling, hvilket er den mest normale kobling til de fleste fustager. Vælger du at leje et anlæg samt fustager, sørger vi naturligvis for at koblingen passer.
          </Paragraph>
          <Paragraph>
            Gå på opdagelse i vores brede sortiment af classic øl, primært fra danske producenter, store som små.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Hvad er en classic øl?
          </Heading2>
          <Paragraph>
            Har du undret dig over, at det er svært at finde en classic øl i udlandet? Det er faktisk ikke så underligt. En classic øl som vi kender den, hedder nemlig ikke det samme i andre lande, som den gør i Danmark. Den bliver fx kaldt for en wienerøl eller märzen, hvilket næsten er det samme, men en classic er en dansk version og en modernisering af de to klassiske udenlandske øltyper. For at give et indblik i classic øllets tilblivelse, er det nødvendigt at beskrive lidt om begge historiske ølvarianter:
          </Paragraph>
          <Paragraph>
            Wienerøl stammer fra Østrig og Ungarn og blev en vældig populær øltype tilbage i 1840’erne, hvor den faktisk gjorde så stort indtryk, at den blev en del af traditionerne.
            Wienerøl er oftest lidt sødere og har en højere alkoholprocent end en almindelig pilsnerøl, hvilket gør, at den egner sig godt til mange tunge eller sødere middagsretter.
            Wienerøl har den karakteristiske gyldne ravfarve med råhvidt skum og en aroma af malt, karamel og ristet toast. Smagen trækker også over i karamelliserede noter og indeholder også en høj maltsødme og balanceret bitterhed.
          </Paragraph>
          <Paragraph>
            Märzen stammer fra det Bayerske område i Tyskland fra før det 16. århundrede. Den karakteriseres også af en fyldig smag med noter af karamel og ristet malt. Den er blød og har masser af smag med en velafbalanceret bitterhed. Farven er, ligesom med wienerøl, en gylden ravfarve eller kobberfarvet, men kan nogle gange svinge lidt mere i nuancerne fra lys til medium mørk.
          </Paragraph>
          <Paragraph>
            En classic øl, som vi kender den i dag, er inspireret af både wienerøl og märzen. Den kendes også nogle gange som en Bayersk øl.
            Classic øl blev for første gang introduceret i Danmark i 1993 og er altså en forholdsvis ny type øl. Den er en modernisering og en form for reintroduktion af de “gamle” øltyper og er mørkere end en almindelig pilsner, men ikke lige så mørk som en lagerøl. Classic øllen har en mørkere nuance og toner gerne i de ravrøde og kobber lignende farver og karakteriseres af fylde og meget aroma. Denne aroma defineres af malten og med en snert af ristet brød.
            Alkoholprocenten i en classic svarer til en almindelig pilsner og ligger oftest på ca. 4,6%.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Lad os introducere dig for flere typer af classic øl
          </Heading2>
          <Paragraph>
            Som tidligere nævnt, finder du som regel en variant af en classic øl fra de fleste danske bryggerier, da det er en vældig populær øl herhjemme.
            Hos Skafte.dk forhandler vi et bredt udvalg af classic øl og du kan læse lidt mere om et lille udvalg af danske varianter nedenfor.
          </Paragraph>
          <Heading3>
            Danske classic øl
          </Heading3>
          <List>
            <li>
              Albani: En Albani Odense Classic har en fyldig og kraftig smag af malt og karakteriseres af en mørk farve. Øllen blev introduceret i 1999 i forbindelse med Albanis 140 års jubilæum.
            </li>
            <li>
              Carlsberg: Carlsberg 1883 er brygget på den gamle gær, der blev brugt tilbage i 1883. Øllen startede som Rebrew i 2016 og blev kun produceret i en begrænset mængde, men blev senere fast sortiment. Denne øl er brygget på den verdens første rendyrkede gær og har en skøn duft af malt og karamel.
            </li>
            <li>
              Royal: Royal Classic er brygget på den kendte Royal malt, men også karamelmalt samt mørkristet malt. Der er desuden også tilsat aromatisk humle, hvilket giver øllen fyldighed og en rig smagsoplevelse.
            </li>
            <li>
              Svaneke: En Svaneke Classic karakteriseres af en flot og gylden ravfarve, mens den har både smag og duft noter af både græs, malt og korn.
            </li>
            <li>
              Tuborg: Den velkendte Tuborg Classic er en gylden mørk pilsner øl med massere af smagsindtryk, der både byder på ristet malt, karamel og en smule sødme. Eftersmagen præges af behagelig bitterhed fra humlen.
            </li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Var det noget med en classic øl leveret direkte?
          </Heading2>
          <Paragraph>
            Skafte leverer til både private, virksomheder og foreninger. Skal vi også levere til dit næste arrangement eller fest? En frisk skænket classic går rent hjem hos de fleste. Og skal der gerne være lidt for enhver smag, så tage evt. et kig på hele vores udvalg af <LinkStyled to="/fadoel">fadøl</LinkStyled>.
          </Paragraph>
          <Paragraph>
            En classic øl er svær at vente på - og netop derfor sørger vi for leveringstid på kun 1-2 dage i Storkøbenhavn, hvis du bestiller inden for almindelig arbejdstid. Du kan naturligvis også selv vælge en dato, der passer dig bedst til levering af classic øl på fustage.
          </Paragraph>
          <Paragraph>
            Har du uåbnede fustager med classic pilsner tilbage efter arrangementet? Bare rolig, vi tager dem gerne retur, så du kun betaler for dem, du tager hul på.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
